export class TwoFactorYubiKeyDeleteRequest {
  constructor(public userVerificationToken: string) {}
}
